export default __webpack_public_path__ + "static/media/about.891cd9ed.jpg";